import { Redirect } from 'expo-router';

import { useMaybeGetLegacyRedirect } from 'components/layout/use-maybe-get-legacy-redirect';
import StaticPageContainer from 'pages/static';

// matches all unmatched routes
// static page handles real not founds after looking for static pages
export default function NotFoundRoute() {
  const redirectUrl = useMaybeGetLegacyRedirect();
  if (redirectUrl) {
    return <Redirect href={redirectUrl} />;
  }

  return <StaticPageContainer />;
}
